import { s as server2server } from "../../../../../chunks/server2server.js";
import { f as fail } from "../../../../../chunks/index.js";
const load = async (event) => {
  const api = server2server(event);
  let client;
  try {
    client = await api.get("/customer/" + event.params.uuid);
  } catch (e) {
    return fail(400);
  }
  return {
    customer: client
  };
};
export {
  load
};
//# sourceMappingURL=_layout.server.ts.js.map
